export default "__VITE_ASSET__Bedhql6G__"